import { Box, Chip, CircularProgress, Tab, Tabs, Typography } from "@mui/material";
import { useTheme } from "@mui/system";
import useStyles from "../styles";

/**
 * Barra de abas CPE / ONU, colada no topo do card de clientes.
 * Compartilhada entre TabCPE e TabOnu (cada um a renderiza acima do seu card).
 */
export default function TabsErp({
	value,
	onChange,
	cpeCount,
	onuCount,
	loadingCpe = false,
	loadingOnu = false,
}) {
	const theme = useTheme();
	const styles = useStyles(theme);

	const label = (texto, count, loading) => (
		<Box sx={styles.boxTab}>
			<>{texto}</>
			<Chip
				label={
					loading ? (
						<CircularProgress size={12} color="inherit" />
					) : (
						count || 0
					)
				}
				size="small"
				sx={styles.stylesChips}
			/>
		</Box>
	);

	return (
		<Tabs value={value} onChange={onChange} sx={styles.tabs}>
			<Tab label={label("CPE", cpeCount, loadingCpe)} />
			<Tab label={label("ONU", onuCount, loadingOnu)} />
		</Tabs>
	);
}
